import { render, staticRenderFns } from "./platform-btn.vue?vue&type=template&id=4306e512&scoped=true&"
import script from "./platform-btn.vue?vue&type=script&lang=ts&"
export * from "./platform-btn.vue?vue&type=script&lang=ts&"
import style0 from "./platform-btn.vue?vue&type=style&index=0&id=4306e512&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4306e512",
  null
  
)

export default component.exports